/*** IMPORTS FROM imports-loader ***/
var define = false;
var exports = false;

/** v1.1.4 - 06/4/21 **/
(function() {
    /**
     * Class used as Observer to allow for listeners and triggering events.
     * All methods are added to the prototype after these variable declarations.
     */
    var EventDispatcher = (function() {
        var theClass = function() {};
        /**
         * Binds a function handler to an event by the event name.
         * A higher priority will mean the handler is called before others
         * with lower or no priority.
         */
        theClass.prototype.on = function(type, handler) {
            var types = type.split(' ');
            if (!this.bindings) this.bindings = {};
            for (var i in types) {
                type = types[i];
                if (!this.bindings[type]) this.bindings[type] = [];
                this.bindings[type].push({ handler: handler });
            }
        };
        /**
         * Removes a particular handler from an event that was added with bind().
         */
        theClass.prototype.off = function(type, handler) {
            var i, totalListeners, listeners, types;

            if (!this.bindings || type == null) {
                this.bindings = {};
            }
            if (type == null) return;
            types = type.split(' ');
            for (var i in types) {
                type = types[i];
                listeners = this.bindings[type];
                if (listeners == null) continue;
                if (handler == null) {
                    delete this.bindings[type];
                } else {
                    totalListeners = listeners.length;
                    for (i = totalListeners - 1; i > -1; i--) {
                        if (listeners[i].handler == handler) {
                            listeners.splice(i, 1);
                        }
                    }
                }
            }
        };
        /**
         * Causes the object to dispatch an event of the specified type.
         * The data parameter is added to the data property of the event
         * that is dispatched.
         */
        theClass.prototype.trigger = function(type, data) {
            if (!this.bindings) {
                this.bindings = {};
            }
            var i,
                totalListeners,
                handler,
                listeners = this.bindings[type],
                event = { type: type, data: data };

            if (listeners == null) return;
            totalListeners = listeners.length;
            for (i = totalListeners - 1; i > -1; i--) {
                handler = listeners[i].handler;
                if (handler.apply(handler, [event]) === false) break;
            }
        };

        return theClass;
    })();

    window.USGAPlayer = function(config) {
        var usgaPlayer = this,
            views = {
                SINGLE: 'single',
                PIP: 'pip',
            },
            players = {},
            liveIndicators = {},
            playerCaptions = {},
            contentPlayers = [],
            adPlayerLoaded = false,
            endStream = null,
            adPlayer = null,
            adsRequested = false,
            globalPlayer = null,
            globalControlBar = null,
            streams = null,
            pipSettings = { dragging: false },
            uaString = navigator.userAgent,
            isIE11 = /(?=.*Trident\/7.0)/i.test(uaString),
            container = document.createElement('div'),
            videos = document.createElement('div'),
            pipPlayerRef,
            currentVideoHighlightState,
            previousLivePiPVideo,
            currentPiPtype,
            isHighlightView,
            pipIsSelected = false,
            pipControls = document.createElement('div'),
            topNavigation = document.createElement('div'),
            topNavigationHTML =
                "<div id='top-nav-labels'><div>&nbsp;</div><div>&nbsp;</div></div>" +
                "<div id='top-nav-buttons'><div id='view-buttons'>" +
                "<div data-view='single'></div><div data-view='pip'></div>" +
                '</div><div>Channel Views</div></div>',
            firstPlayerError = null,
            /* utility for looping over nodelists */
            forEach = function(array, func) {
                var count = array.length;
                for (var i = 0; i < count; i++) {
                    func.call(array[i], i);
                }
            },
            getPlayerType = function(id) {
                return videos.children[0].getAttribute('id') === id
                    ? 'main'
                    : 'pip';
            },
            /* makes the specified quadrant the first child video in videos element */
            makeFirstQuadrant = function(video, playing, view) {
                var children = videos.children,
                    nodes = [video],
                    totalNodes = children.length;

                for (var i = 0; i < totalNodes; i++) {
                    if (children[i] == video) continue;
                    nodes.push(children[i]);
                }
                // if not delayed, the DOM gets reordered oddle
                setTimeout(function() {
                    for (var i = 0; i < totalNodes; i++) {
                        videos.appendChild(nodes[i]);
                    }
                    pausePlayersNotInView(view);
                    config.element.setAttribute('data-view', view);
                    globalControlBar.hookGlobalControls(adPlayerLoaded);
                    hookPiPControls();
                }, 40);
                return true;
            },
            /* retrieves displayed videos and triggers an event to page */
            triggerViewChange = function(toView) {
                var displayedVideos = [],
                    videoPlayers = videos.children;

                switch (toView) {
                    case views.SINGLE:
                        displayedVideos.push(videoPlayers[0].dataset.videoId);
                        /* 
                        the following line is either redundant or needs to be replaced in favor of:

                            streams.find(function(v) {
                                return v.id == videos.children[1].getAttribute("data-video-id")
                            });
                        
                        */
                        previousLivePiPVideo =
                            (videos.children[1] &&
                                streams[
                                    videos.children[1].getAttribute(
                                        'data-video',
                                    )
                                ]) ||
                            null;
                        selectPlayer(videoPlayers[0]);
                        break;
                    case views.PIP:
                        displayedVideos.push(
                            videoPlayers[0].dataset.videoId,
                            videoPlayers[1].dataset.videoId,
                        );
                        break;
                }
                updateSlateControls();
                updateSafariControls();
                usgaPlayer.trigger('viewChange', {
                    view: toView,
                    videos: displayedVideos,
                });
            },
            /* changes the layout/view of the player and its videos */
            setView = function(toView) {
                var pipPlayer = null,
                    playing = getPlayersPlaying(),
                    delayClass = false,
                    selectedQuadrant = document.querySelector(
                        '.video-js.usga-selected',
                    ),
                    index = selectedQuadrant
                        ? Array.prototype.indexOf.call(
                              videos.children,
                              selectedQuadrant,
                          )
                        : -1,
                    fromView = config.element.getAttribute('data-view');

                if (isHighlightView) index = 0;
                if (toView == fromView) return;

                // determine which quadrants should appear
                switch (fromView) {
                    case views.PIP:
                        pipPlayer = videos.children[1];
                        pipControls
                            .querySelector('#swap-button')
                            .removeEventListener('click', swapPiP);
                        pipPlayer.removeEventListener(
                            'toushstart',
                            startDragPiP,
                        );
                        pipPlayer.removeEventListener(
                            'mousedown',
                            startDragPiP,
                        );
                        pipControls.parentNode.removeChild(pipControls);
                        pipSettings.top = pipPlayer.style.top;
                        pipSettings.left = pipPlayer.style.left;
                        pipPlayer.style.top = '';
                        pipPlayer.style.left = '';
                        if (!isHighlightView) {
                            previousLivePiPVideo =
                                streams[pipPlayer.getAttribute('data-video')];
                        }
                        if (
                            pipPlayer !== selectedQuadrant &&
                            !isHighlightView
                        ) {
                            pipPlayer.player.pause();
                        } else {
                            if (isHighlightView) {
                                setLiveVideoInPiPFn(
                                    previousLivePiPVideo || streams[1],
                                    true,
                                    videos.children[1].player.pause,
                                );
                                isHighlightView = false;
                            } else {
                                videos.children[0].player.pause();
                            }
                        }
                        videojs(
                            document.querySelectorAll('.video-js video')[0],
                        ).muted(globalControlBar.getGlobalMuteState());
                        switch (toView) {
                            case views.SINGLE:
                                // all but 0 needs DOM manipulation
                                if (index > 0) {
                                    pipPlayer.player.play();
                                    delayClass = makeFirstQuadrant(
                                        selectedQuadrant,
                                        playing,
                                        toView,
                                    );
                                }
                                break;
                        }
                        break;
                }
                if (toView === views.SINGLE) {
                    usgaPlayer.enablePipSwap();
                }
                // Resume PiP Play
                if (toView === views.PIP) {
                    pipPlayer = videos.children[1];
                    previousLivePiPVideo =
                        previousLivePiPVideo ||
                        streams[pipPlayer.getAttribute('data-video')];
                    pipPlayer.player.muted(true);
                    pipPlayer.player.play();
                }
                if (
                    [views.SINGLE, views.PIP].indexOf(toView) > -1 &&
                    !delayClass
                )
                    globalControlBar.hookGlobalControls(adPlayerLoaded);

                // select button and set class on main element
                if (!delayClass) {
                    pausePlayersNotInView(toView);
                    config.element.setAttribute('data-view', toView);
                    hookPiPControls();
                }
                hideCaptionsBetweenViews();
                forEach(
                    document.querySelectorAll('#view-buttons>div'),
                    function() {
                        this.className = '';
                    },
                );
                document.querySelector(
                    "#view-buttons>div[data-view='" + toView + "']",
                ).className = 'selected';
                setTimeout(function() {
                    triggerViewChange(toView);
                }, 500);
            },
            /*
             * hide any visible captions when user switches Views to avoid display
             * with incorrect styling - captions will automatically display again
             * when next caption appears
             */
            hideCaptionsBetweenViews = function() {
                var textTrackDivs = document.querySelectorAll(
                    '.vjs-text-track-display',
                );

                forEach(textTrackDivs, function(i) {
                    if (this.childNodes.length) {
                        this.childNodes[0].style.display = 'none';
                    }
                });
            },
            /*
             * looks through child nodes for slate div and removes from DOM
             */
            removeSlate = function(player) {
                var childElements = player.el().childNodes;

                // look for 'bgs-player-empty' class & remove
                if (player.el().className.indexOf(' bgs-player-empty') > 0) {
                    player.el().className = player
                        .el()
                        .className.split(' bgs-player-empty')
                        .join('');
                }

                // look for player slate & remove
                for (var i in childElements) {
                    if (
                        childElements[i] &&
                        childElements[i].className == 'player-slate'
                    ) {
                        player.el().removeChild(childElements[i]);
                    }
                }
                updateSlateControls();
            },
            /*
             * handles whether a live indicator should be placed on 'usga-controls' bar
             * @param player - Object - Brightcove Video Player object
             */
            handleLiveVideo = function(player) {
                var playerControls = player
                    .el()
                    .querySelector('.usga-controls');
                if (player.duration() == Infinity) {
                    playerControls.className += ' dvr-ready';
                } else {
                    playerControls.className = playerControls.className
                        .split(' dvr-ready')
                        .join('');
                }
            },
            /*
             * runs through player set up
             * @param isPreroll - Boolean - set to 'true' if you are setting up a player
             *      specifically for trafficking Pre-roll ads
             */
            setupPlayer = function(isPreroll) {
                var player, id, vjsPlayer, firstPlayer;

                if (isPreroll) {
                    player = document.querySelector('.video-js');
                    id = player.getAttribute('id');

                    vjsPlayer = players[id] = videojs(id);

                    setView(views.SINGLE);

                    selectPlayer(vjsPlayer.el(), true);

                    globalControlBar.setPlayers(players);
                    globalControlBar.setInitialPlayerVolume();

                    // set container class name
                    container.className += ' ad-player';

                    vjsPlayer.on('error', function() {
                        usgaPlayer.trigger('errorReport', {
                            player: this,
                            error: this.error(),
                        });
                        firstPlayerError = this.error().code;
                    });
                    vjsPlayer.on('loadedmetadata', function() {
                        var playerType = getPlayerType(this.id());
                        usgaPlayer.trigger('videoLoaded', {
                            video: this.mediainfo,
                            player: this,
                            playerType: playerType,
                        });
                    });
                } else {
                    forEach(document.querySelectorAll('.video-js'), function(
                        i,
                    ) {
                        var player = this,
                            playerReconnect,
                            slate = null,
                            vjsPlayer = null,
                            id = player.getAttribute('id');

                        // get VideoJS wrapper
                        vjsPlayer = players[id] = videojs(id);

                        vjsPlayer.off(
                            'timeupdate',
                            displayRemainingTime(vjsPlayer, players[id].el_),
                        );
                        addControls(vjsPlayer);
                        vjsPlayer.on(
                            'timeupdate',
                            displayRemainingTime(vjsPlayer, players[id].el_),
                        );

                        if (i === 0 && adPlayer) {
                            handleLiveVideo(vjsPlayer);
                            liveIndicators[id].seekToLive();
                        }

                        playerReconnect = new USGAPlayer.USGAPlayerReconnect(
                            vjsPlayer,
                            config.debug,
                            new EventDispatcher(),
                        );

                        playerReconnect.prototype.on(
                            'showSlate',
                            onPlayerShowSlate,
                        );
                        playerReconnect.prototype.on(
                            'hideSlate',
                            onPlayerHideSlate,
                        );
                        playerReconnect.prototype.on('videoExit', function(e) {
                            var playerType = getPlayerType(e.data.player.id());
                            usgaPlayer.trigger('videoExit', {
                                video: e.data.video,
                                player: e.data.player,
                                playerType: playerType,
                            });
                        });

                        if (firstPlayerError && i === 0 && adPlayer) {
                            playerReconnect._onMediaPlayerError(
                                firstPlayerError,
                            );
                            if (
                                firstPlayerError == 'PLAYER_ERR_GEO_RESTRICTED'
                            ) {
                                slate = new USGAPlayer.USGAHTMLSlate(
                                    vjsPlayer.el(),
                                    USGAPlayer.USGAHTMLSlate.Type.GEO_RESTRICTED,
                                    new EventDispatcher(),
                                );
                                slate.createSlate();
                                updateSlateControls();
                            }
                        }

                        // add slate to any players that don't load with a video
                        if (
                            !player
                                .querySelector('video')
                                .getAttribute('data-video-id')
                        ) {
                            slate = new USGAPlayer.USGAHTMLSlate(
                                vjsPlayer.el(),
                                USGAPlayer.USGAHTMLSlate.Type.EMPTY_PLAYER,
                                new EventDispatcher(),
                            );
                            slate.createSlate();
                            // updateSlateControls();
                        }

                        if (!adPlayer || i > 0) {
                            vjsPlayer.on('loadedmetadata', function() {
                                var playerType = getPlayerType(this.id());
                                usgaPlayer.trigger('videoLoaded', {
                                    video: this.mediainfo,
                                    player: this,
                                    playerType: playerType,
                                });
                            });
                        }
                        vjsPlayer.ready(function() {
                            vjsPlayer.on(
                                'ended',
                                onMediaComplete.bind(vjsPlayer),
                            );
                        });

                        vjsPlayer.on('error', function() {
                            onMediaPlayerError(vjsPlayer);
                        });

                        if (!firstPlayer) {
                            firstPlayer = vjsPlayer;
                        }
                    });

                    // set to single if mobile or IE11
                    if (container.className.indexOf(' bgs-mobile') > -1) {
                        setView(views.SINGLE);
                    } else if (isIE11) {
                        setView(views.SINGLE);
                        container.className += ' bgs-ie11';
                    } else {
                        setView(config.layout || views.SINGLE);
                    }

                    // enable view buttons
                    forEach(
                        document.querySelectorAll('#view-buttons>div'),
                        function() {
                            this.addEventListener('click', function() {
                                setView(this.getAttribute('data-view'));
                            });
                        },
                    );

                    selectPlayer(firstPlayer.el(), adPlayer ? false : true);

                    if (!adPlayer) {
                        globalControlBar.setInitialPlayerVolume();
                    } else {
                        firstPlayer.one(
                            ['contenttimeupdate', 'timeupdate'],
                            function() {
                                globalControlBar.setInitialPlayerVolume();
                            },
                        );
                    }

                    firstPlayer.on('playerresize', onPlayerResize);

                    globalControlBar.setPlayers(players);
                    globalControlBar.hookGlobalControls(false);

                    // set container class name
                    if (container.className.indexOf(' ad-player') > -1) {
                        container.className = container.className
                            .split(' ad-player')
                            .join('');
                    }
                }
            },
            onPlayerResize = function(e) {
                var mainPlayer = videos.children[0],
                    pipPlayer = videos.children[1],
                    pipPlayerBounds = pipPlayer.getBoundingClientRect(),
                    containerBounds = videos.getBoundingClientRect(),
                    mainPlayerWidth = mainPlayer.offsetWidth,
                    mainPlayerHeight = mainPlayer.offsetHeight,
                    maxX = containerBounds.width - pipPlayerBounds.width,
                    maxY = containerBounds.height - pipPlayerBounds.height,
                    placementY =
                        (Math.max(0, maxY) / mainPlayerHeight) * 100 + '%',
                    placementX =
                        (Math.max(0, maxX) / mainPlayerWidth) * 100 + '%';

                if (config.element.getAttribute('data-view') == views.PIP) {
                    if (pipPlayer.style.left >= placementX)
                        pipPlayer.style.left = placementX;
                    if (pipPlayer.style.top >= placementY)
                        pipPlayer.style.top = placementY;
                }
            },
            onPlayerShowSlate = function(e) {
                var slate,
                    player = e.data.player;

                slate = new USGAPlayer.USGAHTMLSlate(
                    player.el(),
                    USGAPlayer.USGAHTMLSlate.Type.STREAM_ERROR,
                    new EventDispatcher(),
                );
                slate.createSlate();
                updateSlateControls();
            },
            onPlayerHideSlate = function(e) {
                var player = e.data.player;
                removeSlate(player);
            },
            onStreamEnded = function(e) {
                usgaPlayer.trigger('videoComplete', {
                    event: 'complete',
                    video: e.data.video,
                    player: e.data.player,
                });
            },
            /* load full list of players into DOM that will be used for content playback */
            createContentPlayers = function() {
                var playerLength = adPlayer ? 1 : 2,
                    isIPhone = /(?=.*iPhone)(?=.*Mobile)/i.test(uaString),
                    isAndroidPhone = /(?=.*Android)(?=.*Mobile)/i.test(
                        uaString,
                    );

                if (
                    isIE11 ||
                    ((isAndroidPhone || isIPhone) &&
                        container.className.indexOf(' bgs-mobile') > -1)
                ) {
                    playerLength = 1;
                }

                for (var i = 0; i < playerLength; i++) {
                    contentPlayers.push(
                        new USGAPlayer.USGAPlayerInstance(
                            videos,
                            config,
                            globalControlBar,
                            new EventDispatcher(),
                        ),
                    );
                    contentPlayers[i].prototype.on(
                        'streamEnded',
                        onStreamEnded,
                    );
                }
                // contentPlayers && contentPlayers.length && contentPLayers[0]._player.on("timeupdate", function() {
                //     var tracks = this.textTracks();
                //     var hasCaptions = false;
                //     for (var i = 0; i < tracks.length; i++) {
                //         var track = tracks[i];
                //         // Find the English captions track and mark it as "showing".
                //         if (track.kind === 'captions') {
                //             hasCaptions = true;
                //             break
                //         }
                //         }
                //     if (!hasCaptions) {
                //         this.el_.parentElement.parentElement.classList.add('no-captions')
                //     } else {
                //         this.el_.parentElement.parentElement.classList.remove('no-captions')
                //     }
                // })
                setupPlayer(false);
            },
            /* creates a player specifically for pre-roll ad playback */
            createAdPlayer = function() {
                // if no ad server url is configured, exit out & render content
                if (!config.adServerURL) {
                    createContentPlayers();
                    return;
                }

                adPlayerLoaded = true;

                adPlayer = new USGAPlayer.USGAPlayerInstance(
                    videos,
                    config,
                    globalControlBar,
                    new EventDispatcher(),
                );
                setupPlayer(true);

                // if ads haven't been requested after 2 seconds; get rid of ad player
                window.setTimeout(function() {
                    if (!adPlayer._adsRequested) {
                        adPlayer.adsEnded();
                        onAdComplete();
                    }
                }, 2000);

                // sets DFP server url through config param
                adPlayer._player.ima3.settings.serverUrl = config.adServerURL;

                adPlayer.prototype.on('adsEnded', onAdComplete);
            },
            /*
             * handles ad complete for DFP Pre-roll
             * disposes player; begins loading player list for content
             */
            onAdComplete = function(evt) {
                adPlayerLoaded = false;
                adPlayer._player.ima3.settings.serverUrl = '';
                // reset list of loaded players
                players = [];
                createContentPlayers();
            },
            /*
             * appends a slate to player section when video completes
             */
            onMediaComplete = function() {
                var playerEl = this.el();

                usgaPlayer.trigger('videoComplete', {
                    event: 'complete',
                    video: this.mediainfo,
                    player: this,
                });
            },
            /**
             * check for general player errors to output to page
             * Note that any redundancy/stream reconnection attempts
             * are handled by bgs_usga_player_reconnect.js
             */
            onMediaPlayerError = function(player) {
                var slate,
                    errorCode = player.error().code;

                // display error slate for geo-restricted videos
                if (errorCode == 'PLAYER_ERR_GEO_RESTRICTED') {
                    slate = new USGAPlayer.USGAHTMLSlate(
                        player.el(),
                        USGAPlayer.USGAHTMLSlate.Type.GEO_RESTRICTED,
                        new EventDispatcher(),
                    );
                    slate.createSlate();
                    updateSlateControls();
                }

                usgaPlayer.trigger('errorReport', {
                    player: player,
                    error: player.error(),
                });
            },
            /* returns an array of which players are currently playing or not */
            getPlayersPlaying = function() {
                var playing = {};
                // determine which are playing
                for (var i in players) {
                    playing[players[i].getAttribute('id')] = {
                        player: players[i],
                        playing: !players[i].paused(),
                    };
                }
                return playing;
            },
            /* causes all players that were playing to resume */
            setPlayersPlaying = function(playing) {
                // make sure they are still playing
                for (var i in playing) {
                    if (playing[i].playing) playing[i].player.play();
                }
            },
            /*
             * Pause all players which are not in view and
             * resume players which were previously paused when they become active on view
             */
            pausePlayersNotInView = function(view) {
                for (var i in players) {
                    if (!players[i].hasClass('usga-selected')) {
                        const playerId = players[i].getAttribute('id');
                        const isLive = players[i].duration() == Infinity;
                        const liveIndicator = liveIndicators[playerId];
                        const playerPaused = players[i].paused();
                        if (view === views.SINGLE && !playerPaused) {
                            // Not sure if this is a wanted behavior (pauses the main video window on view change)
                            // players[i].pause();
                        } else if (view === views.PIP) {
                            videos.children[0].getAttribute('id') ===
                                playerId ||
                            videos.children[1].getAttribute('id') === playerId
                                ? !isLive
                                    ? players[i].play()
                                    : liveIndicator.seekToLive()
                                : players[i].pause();
                        }
                    }
                }
            },
            /* creates the controls for the PiP player */
            createPiPControls = function() {
                pipControls.setAttribute('id', 'pip-controls');
                pipControls.innerHTML =
                    "<div id='move-button'></div>" +
                    "<div id='swap-button'><span>SWAP</span><div></div></div>" +
                    "<div id='close-button'></div>";
            },
            /* hooks up PiP controls to current set up */
            hookPiPControls = function() {
                // add PiP controls
                if (config.element.getAttribute('data-view') == views.PIP) {
                    var pipPlayer = videos.children[1];
                    pipPlayerRef = pipPlayer.player;
                    pipPlayer.appendChild(pipControls);
                    pipPlayer.style.top = pipSettings.top;
                    pipPlayer.style.left = pipSettings.left;
                    pipControls
                        .querySelector('#swap-button')
                        .addEventListener('click', swapPiP);
                    pipPlayer.addEventListener('mousedown', startDragPiP);
                    pipPlayer.addEventListener('touchstart', startDragPiP);
                    pipControls
                        .querySelector('#close-button')
                        .addEventListener('click', function() {
                            selectPlayer(videos.children[0]);
                            setView(views.SINGLE);
                        });
                }
            },
            /* swaps the two players in PiP view */
            swapPiP = function() {
                var playing = getPlayersPlaying(),
                    mainPlayer;

                videos.appendChild(videos.children[0]);
                videos.appendChild(videos.children[1]);
                mainPlayer = videos.children[0];
                previousLivePiPVideo = streams.find(function(v) {
                    return (
                        v.id == videos.children[1].getAttribute('data-video-id')
                    );
                });
                pipSettings.top = mainPlayer.style.top;
                pipSettings.left = mainPlayer.style.left;
                mainPlayer.style.top = '';
                mainPlayer.style.left = '';
                setPlayersPlaying(playing);
                hookPiPControls();
                hideCaptionsBetweenViews();
                globalControlBar.hookGlobalControls();
                usgaPlayer.trigger('swapPip', {
                    mainPlayer: videos.children[0].player,
                    pipPlayer: videos.children[1].player,
                });
                updateSafariControls();
                updateSlateControls();
            },
            /* makes the PiP draggable */
            startDragPiP = function(e) {
                if (pipSettings.dragging) return;
                var player = videos.children[1],
                    style = player.style,
                    playerBounds = player.getBoundingClientRect(),
                    containerBounds = videos.getBoundingClientRect(),
                    maxX = containerBounds.width - playerBounds.width,
                    maxY = containerBounds.height - playerBounds.height,
                    offsetLeft = e.targetTouches
                        ? e.targetTouches[0].pageX
                        : e.clientX,
                    offsetTop = e.targetTouches
                        ? e.targetTouches[0].pageY
                        : e.clientY,
                    /* stops the dragging of the PiP */
                    stopDragPiP = function() {
                        document.removeEventListener('mouseup', stopDragPiP);
                        document.removeEventListener('touchend', stopDragPiP);
                        document.removeEventListener('mousemove', dragPiP);
                        document.removeEventListener('touchmove', dragPiP);
                        pipSettings.dragging = false;
                    },
                    /* moves the PiP around the player */
                    dragPiP = function(e) {
                        var placementY,
                            placementX,
                            mainPlayer = videos.children[0],
                            playerWidth = mainPlayer.offsetWidth,
                            playerHeight = mainPlayer.offsetHeight,
                            x = e.targetTouches
                                ? e.targetTouches[0].pageX
                                : e.clientX,
                            y = e.targetTouches
                                ? e.targetTouches[0].pageY
                                : e.clientY;

                        // convert into a percentage...
                        placementY =
                            (Math.max(0, Math.min(maxY, y - offsetTop)) /
                                playerHeight) *
                                100 +
                            '%';
                        placementX =
                            Math.max(
                                0,
                                Math.min(maxX, x - offsetLeft) / playerWidth,
                            ) *
                                100 +
                            '%';
                        videos.children[1].style.top = placementY;
                        videos.children[1].style.left = placementX;
                    };

                offsetTop -= playerBounds.top - containerBounds.top;
                offsetLeft -= playerBounds.left - containerBounds.left;
                document.addEventListener('touchmove', dragPiP);
                document.addEventListener('mousemove', dragPiP);
                document.addEventListener('mouseup', stopDragPiP);
                document.addEventListener('touchend', stopDragPiP);
                pipSettings.dragging = true;
            },
            convertTime = function(sec) {
                if (sec !== Infinity && sec !== NaN) {
                    var hours = Math.floor(sec / 3600);
                    hours >= 1 ? (sec = sec - hours * 3600) : (hours = '00');
                    var min = Math.floor(sec / 60);
                    min >= 1 ? (sec = sec - min * 60) : (min = '00');
                    sec < 1 ? (sec = '00') : void 0;
                    min.toString().length == 1 ? (min = '0' + min) : void 0;
                    sec.toString().length == 1 ? (sec = '0' + sec) : void 0;
                    return (
                        hours +
                        ':' +
                        min +
                        ':' +
                        (sec.toString() === 'NaN' ? '00' : sec)
                    );
                } else {
                    return '00:00:00';
                }
            };
        (displayRemainingTime = function(player, el) {
            return function() {
                var time = player.remainingTimeDisplay();
                var duration = convertTime(Math.floor(player.duration()));
                if (time !== NaN || time !== Infinity) {
                    var elapsedTime = convertTime(
                        Math.floor(player.duration() - time),
                    );
                    el.querySelector('.pip-time').innerHTML =
                        elapsedTime + ' / ' + duration;
                } else {
                    el.querySelector('.pip-time').innerHTML =
                        '00:00:00 / 00:00:00';
                }
            };
        }),
            /* PIP Controls */
            /* creates small controls per player */
            (addControls = function(player) {
                var liveIndicator,
                    border = document.createElement('div'),
                    controls = document.createElement('div'),
                    playerEl = player.el();

                border.className = 'video-border';
                playerEl.insertBefore(border, playerEl.firstChild);
                controls.className = 'usga-controls pip-controls';
                controls.innerHTML =
                    "<div class='play-button'></div><div class='live-button'></div><div class='skip-back'></div><div class='pip-time'></div><div class='previous-video'></div><div class='next-video'></div>";

                if (!playerEl.querySelector('.usga-controls')) {
                    playerEl.appendChild(controls);
                }

                liveIndicator = new USGAPlayer.USGALiveIndicator(
                    controls.querySelector('.live-button'),
                    false,
                    player,
                    new EventDispatcher(),
                );
                // save reference to indicator
                liveIndicators[player.getAttribute('id')] = liveIndicator;

                border.addEventListener('click', function() {
                    selectPlayer(player.el_);
                });
                playerEl
                    .querySelector('.live-button')
                    .addEventListener('click', function() {
                        liveIndicator.seekToLive();
                    });
                playerEl
                    .querySelector('.skip-back')
                    .addEventListener('click', function() {
                        player.currentTime(
                            Math.max(0, player.currentTime() - 30),
                        );
                    });
                playerEl
                    .querySelector('.play-button')
                    .addEventListener('click', function() {
                        player.paused() ? player.play() : player.pause();
                    });
                playerEl
                    .querySelector('.next-video')
                    .addEventListener('click', function() {
                        usgaPlayer.trigger('playNextHighlight');
                        playNextPipVideo();
                    });
                playerEl
                    .querySelector('.previous-video')
                    .addEventListener('click', function() {
                        usgaPlayer.trigger('playPreviousHighlight');
                        playPreviousPipVideo();
                    });
            }),
            /* changes the top labels based on the two values */
            (updateLabels = function(top, bottom) {
                document.querySelector(
                    '#top-nav-labels>div:first-child',
                ).innerHTML = top;
                document.querySelector(
                    '#top-nav-labels>div:nth-child(2)',
                ).innerHTML = bottom;
            }),
            /* loads Brightcove Player JS */
            (loadPlayerScript = function() {
                var next = function() {},
                    script = document.createElement('script');

                script.onload = function() {
                    next();
                };
                script.src = '//players.brightcove.net/{account}/{player}_default/index.min.js'
                    .replace('{account}', config.account)
                    .replace('{player}', config.player);
                document.head.appendChild(script);
                return {
                    then: function(callback) {
                        next = callback;
                    },
                };
            }),
            /* visually selects player and updates labels */
            (selectPlayer = function(player, initial) {
                var video = streams
                        ? streams[player.getAttribute('data-video')]
                        : null,
                    id = player.getAttribute('id'),
                    isAndroidPhone = /(?=.*Android)(?=.*Mobile)/i.test(
                        navigator.userAgent,
                    ),
                    isSafari = /(?=^.*Safari)(?!^.*Chrome)/i.test(
                        navigator.userAgent,
                    ),
                    i;
                // add selected class to currently selected
                if (!initial || !adPlayer) {
                    if (video) {
                        updateLabels(video.header, video.title);
                    }
                }

                if (player.className.indexOf('usga-selected') > -1) return;
                // remove selected class from all
                forEach(player.parentNode.children, function() {
                    this.className = this.className
                        .split(' usga-selected')
                        .join('');
                });

                player.className += ' usga-selected';
                usgaPlayer.trigger('videoSelect', {
                    video: video,
                    player: player,
                });
                globalControlBar.setSelectedPlayer(players[id]);
                // mute all players except currently selected
                for (i in players) {
                    (function() {
                        var thisID = players[i].getAttribute('id'),
                            // detect for Safari, verify Chrome is not in user agent string
                            mute =
                                thisID != id ||
                                globalControlBar.getGlobalMuteState() ||
                                initial === true;

                        players[thisID].muted(mute);
                    })();
                }

                // update header if player slate is loaded
                for (var i in player.childNodes) {
                    if (player.childNodes[i].className == 'player-slate') {
                        updateLabels(
                            USGAPlayer.USGAHTMLSlate.Header.EMPTY_PLAYER,
                            '',
                        );
                    }
                }
            }),
            (loadGlobalControlBar = function() {
                globalControlBar = new USGAPlayer.USGAGlobalControls(
                    container,
                    players,
                );
                globalControlBar.prototype = new EventDispatcher();
                globalControlBar.createControls();
            }),
            (onPlayerScriptLoaded = function() {
                if (USGAPlayer.USGAGlobalControls) {
                    loadGlobalControlBar();
                    bc.usingAdBlocker().then(function(status) {
                        if (status || !config.adServerURL) {
                            createContentPlayers();
                        } else {
                            createAdPlayer();
                        }
                    });
                } else {
                    setTimeout(onPlayerScriptLoaded, 100);
                }
            }),
            (hasNextPipVideo = function() {
                var nextIndex =
                    currentVideoHighlightState.currentVideoIndex + 1;
                var nextHighlight =
                    currentVideoHighlightState.playlist.videos[nextIndex];
                return nextHighlight;
            }),
            (hasPrevPipVideo = function() {
                var prevIndex =
                    currentVideoHighlightState.currentVideoIndex - 1;
                if (prevIndex > -1) {
                    var prevHighlight =
                        currentVideoHighlightState.playlist.videos[prevIndex];
                    return prevHighlight;
                }
                return false;
            }),
            (playNextPipVideo = function() {
                if (hasNextPipVideo()) {
                    setHighlightInPiPFn(
                        currentVideoHighlightState.playlist,
                        currentVideoHighlightState.currentVideoIndex + 1,
                        true,
                    );
                }
            }),
            (playPreviousPipVideo = function() {
                if (hasPrevPipVideo()) {
                    setHighlightInPiPFn(
                        currentVideoHighlightState.playlist,
                        currentVideoHighlightState.currentVideoIndex - 1,
                        true,
                    );
                }
            }),
            (handleHighlightPiPEnded = function(event) {
                var nextIndex =
                    currentVideoHighlightState.currentVideoIndex + 1;
                var nextHighlight =
                    currentVideoHighlightState.playlist.videos[nextIndex];
                usgaPlayer.trigger(
                    'highlightVideoEnd',
                    currentVideoHighlightState,
                );
                if (nextHighlight) {
                    setHighlightInPiPFn(
                        currentVideoHighlightState.playlist,
                        nextIndex,
                        true,
                    );
                } else {
                    videos.children[1].player.el_.querySelector(
                        '.pip-time',
                    ).style.opacity = 0;
                    usgaPlayer.trigger(
                        'highlightPlaylistEnd',
                        currentVideoHighlightState,
                    );

                    setLiveVideoInPiPFn(
                        previousLivePiPVideo || streams[1],
                        true,
                    );
                    usgaPlayer.selectPlayer('main');
                    setView(views.SINGLE);
                    usgaPlayer.enablePipSwap();
                }
            }),
            (setHighlightInPiPFn = function(playlist, index, internal) {
                hookPiPControls();
                if (usgaPlayer.getSelectedView() !== views.PIP) {
                    setView(views.PIP);
                    usgaPlayer.selectPlayer();
                } else {
                    if (!internal) {
                        usgaPlayer.selectPlayer();
                    }
                }
                if (!isHighlightView) {
                    previousLivePiPVideo = streams.find(function(v) {
                        return (
                            v.id == pipPlayerRef.getAttribute('data-video-id')
                        );
                    });
                }
                var slate,
                    player = pipPlayerRef,
                    previousVideoData = player.mediainfo,
                    playerType = getPlayerType(player.id_);

                if (adPlayer && adPlayerLoaded) return;
                var video = playlist.videos[index];
                // remove any slates that may be displayed
                removeSlate(player);
                usgaPlayer.disablePipSwap();
                isHighlightView = true;
                // disable captions on selected player
                // Why are we disabling??
                // globalControlBar.disableCaptionsForSelectedPlayer();

                player.off('ended', handleHighlightPiPEnded.bind(this));
                player.one('ended', handleHighlightPiPEnded.bind(this));
                player.one('loadedmetadata', function() {
                    videos.children[1].player.el_.querySelector(
                        '.pip-time',
                    ).style.opacity = 1;
                });
                player.catalog.getVideo(video.id, function(error, data) {
                    if (
                        previousVideoData.id &&
                        data.id !== previousVideoData.id
                    ) {
                        usgaPlayer.trigger('videoExit', {
                            video: previousVideoData,
                            player: player,
                            playerType: playerType,
                        });
                    }

                    // load slate if geo-restriction error is found...
                    if (error) {
                        if (error.response) {
                            if (error.response.indexOf('client_geo') < 0) {
                                return;
                            }

                            slate = new USGAPlayer.USGAHTMLSlate(
                                player.el(),
                                USGAPlayer.USGAHTMLSlate.Type.GEO_RESTRICTED,
                                new EventDispatcher(),
                            );
                            slate.createSlate();
                            updateSlateControls();
                            player.trigger('getVideoError', {
                                video,
                                errorMessage: 'GEO_RESTRICTED',
                            });

                            // @todo: if playable video is loaded before geo-restriction video, it will remain loaded
                            //      -- can video be unloaded?
                            player.reset();
                            return;
                        }
                    }
                    currentVideoHighlightState = {
                        currentVideo: video,
                        currentVideoIndex: index,
                        playlist: playlist,
                    };
                    currentPiPtype = 'highlight';
                    usgaPlayer.trigger(
                        'highlightVideoStart',
                        currentVideoHighlightState,
                    );

                    player.catalog.load(data);
                    player.play();

                    streams[player.getAttribute('data-video')] = video;
                    updateLabels(video.header, video.title);

                    for (var i in contentPlayers) {
                        if (player.id_ == contentPlayers[i]._playerId) {
                            contentPlayers[i]._initialTimeUpdate = false;
                        }
                    }
                    globalControlBar.resetSelectedPlayerMuteState();
                });
            }),
            (setPosterImage = function(videoData, player) {
                if (videoData.poster_sources) {
                    const posters = videoData.poster_sources.filter(function(
                        p,
                    ) {
                        return p.src.substr(0, 5) === 'https';
                    });
                    if (posters.length) {
                        player.poster(posters[0].src);
                    }
                }
            }),
            (setLiveVideoInPiPFn = function(video, initialMute, cb) {
                var slate,
                    player = pipPlayerRef,
                    previousVideoData = player.mediainfo,
                    playerType = getPlayerType(player.id_);

                if (adPlayer && adPlayerLoaded) return;
                //If it's the PiP that's currently selected. Set pip type to live
                if (
                    videos.children[1] &&
                    videos.children[1].id === player.el_.id
                ) {
                    currentPiPtype = 'live';
                }
                // remove any slates that may be displayed
                removeSlate(player);

                // disable captions on selected player
                // Why are we disabling? Commented out to allow for global captions
                // globalControlBar.disableCaptionsForSelectedPlayer();

                player.catalog.getVideo(video.id, function(error, data) {
                    if (
                        previousVideoData.id &&
                        data.id !== previousVideoData.id
                    ) {
                        usgaPlayer.trigger('videoExit', {
                            video: previousVideoData,
                            player: player,
                            playerType: playerType,
                        });
                    }

                    // load slate if geo-restriction error is found...
                    if (error && error.response) {
                        if (error.response.indexOf('client_geo') < 0) {
                            return;
                        }

                        slate = new USGAPlayer.USGAHTMLSlate(
                            player.el(),
                            USGAPlayer.USGAHTMLSlate.Type.GEO_RESTRICTED,
                            new EventDispatcher(),
                        );
                        slate.createSlate();
                        updateSlateControls();
                        player.trigger('getVideoError', {
                            video,
                            errorMessage: 'GEO_RESTRICTED',
                        });

                        // @todo: if playable video is loaded before geo-restriction video, it will remain loaded
                        //      -- can video be unloaded?
                        player.reset();
                        return;
                    }
                    player.catalog.load(data);

                    streams[player.getAttribute('data-video')] = video;
                    previousLivePiPVideo = video;
                    updateLabels(video.header, video.title);

                    for (var i in contentPlayers) {
                        if (player.id_ == contentPlayers[i]._playerId) {
                            contentPlayers[i]._initialTimeUpdate = false;
                        }
                    }
                    if (!initialMute) {
                        globalControlBar.resetSelectedPlayerMuteState();
                    } else {
                        player.muted(initialMute);
                    }
                    if (cb) {
                        cb();
                    }
                });
            });
        window.globalControlBar = function() {
            return globalControlBar;
        };
        // check for required params
        if (!config.account) throw Error('account not passed in config');
        if (!config.player) throw Error('player not passed in config');
        if (!config.element) config.element = document.body;
        if (!config.debug) config.debug = false;

        videos.setAttribute('id', 'videos');

        topNavigation.setAttribute('id', 'player-navigation');
        topNavigation.innerHTML = topNavigationHTML;
        if (document.getElementById('inner-player')) {
            container = document.getElementById('inner-player');
            container.appendChild(topNavigation);
            container.appendChild(videos);
            createPiPControls();
        }
        // set ids, layer DOM
        else {
            container.setAttribute('id', 'inner-player');
            container.className = 'loaded live_player';
            container.appendChild(topNavigation);
            container.appendChild(videos);
            createPiPControls();
            config.element.appendChild(container);
        }

        streams = config.videos;

        // loads Brightcove Player JS, then creates four player elements
        loadPlayerScript().then(onPlayerScriptLoaded);

        /* APIS FOR THE PLAYER */

        // changes the video in the currently selected, expects:
        // {id:number, header:string, title:string}
        (this.setVideoInSelected = function(video) {
            var slate,
                player = this.getSelectedPlayer(),
                previousVideoData = player.mediainfo,
                playerType = getPlayerType(player.id_);

            if (adPlayer && adPlayerLoaded) return;
            //If it's the PiP that's currently selected. Set pip type to live
            if (videos.children[1] && videos.children[1].id === player.el_.id) {
                currentPiPtype = 'live';
                pipIsSelected = true;
                previousLivePiPVideo = video;
            } else {
                pipIsSelected = false;
            }

            this.enablePipSwap();
            // remove any slates that may be displayed
            removeSlate(player);
            updateSlateControls();

            // disable captions on selected player
            // Why disable??
            // globalControlBar.disableCaptionsForSelectedPlayer();

            player.catalog.getVideo(video.id, function(error, data) {
                if (previousVideoData.id && data.id !== previousVideoData.id) {
                    usgaPlayer.trigger('videoExit', {
                        video: previousVideoData,
                        player: player,
                        playerType: playerType,
                    });
                }

                // load slate if geo-restriction error is found...
                if (error && error.response) {
                    if (error.response.indexOf('client_geo') < 0) {
                        return;
                    }

                    slate = new USGAPlayer.USGAHTMLSlate(
                        player.el(),
                        USGAPlayer.USGAHTMLSlate.Type.GEO_RESTRICTED,
                        new EventDispatcher(),
                    );
                    slate.createSlate();
                    updateSlateControls();
                    player.trigger('getVideoError', {
                        video,
                        errorMessage: 'GEO_RESTRICTED',
                    });

                    // @todo: if playable video is loaded before geo-restriction video, it will remain loaded
                    //      -- can video be unloaded?
                    player.reset();
                    return;
                }
                player.catalog.load(data);

                streams[player.getAttribute('data-video')] = video;

                if (pipIsSelected) {
                    previousLivePiPVideo = video;
                }
                updateLabels(video.header, video.title);

                for (var i in contentPlayers) {
                    if (player.id_ == contentPlayers[i]._playerId) {
                        contentPlayers[i]._initialTimeUpdate = false;
                    }
                }
                // This timeout is necessary when the ima plugin is enabled. Didn't dig too far into it.
                setTimeout(function() {
                    globalControlBar.setCaptionsForAllPlayers(
                        globalControlBar.getCaptionsState(),
                    );
                }, 2000);
                globalControlBar.resetSelectedPlayerMuteState();
            });
        }),
            (updateSlateControls = function() {
                document.querySelectorAll('.video-js').forEach(function(el, i) {
                    const playerSlateElement = el.querySelector(
                        '.player-slate',
                    );
                    if (playerSlateElement) {
                        //first element is main player
                        if (i == 0) {
                            globalControlBar.hideControlBar();
                        } else {
                            el.querySelector(
                                '.usga-controls.pip-controls',
                            ).style.opacity = 0;
                        }
                    } else {
                        if (i == 0) {
                            globalControlBar.showControlBar();
                        } else {
                            el.querySelector(
                                '.usga-controls.pip-controls',
                            ).removeAttribute('style');
                        }
                    }
                });
            }),
            /* Added extra classes to video element on safari to style captions */
            (updateSafariControls = function() {
                const isSafari = /(?=^.*Safari)(?!^.*Chrome)/i.test(
                    navigator.userAgent,
                );
                if (isSafari) {
                    document
                        .querySelectorAll('.video-js')
                        .forEach(function(el, i) {
                            const videoEl = el.querySelector('.vjs-tech');
                            if (i == 0) {
                                videoEl.classList.remove('pip-player');
                                if (
                                    container.className.indexOf(' bgs-mobile') >
                                    -1
                                ) {
                                    videoEl.classList.add('player-mobile');
                                } else {
                                    videoEl.classList.remove('player-mobile');
                                }
                            } else {
                                videoEl.classList.add('pip-player');
                                videoEl.classList.remove('player-mobile');
                            }
                        });
                }
            }),
            (this.setLiveVideoInPiP = setLiveVideoInPiPFn.bind(this));
        this.setHighlightInPiP = setHighlightInPiPFn;
        // {id:number, header:string, title:string}

        // changes all videos in the player
        this.setVideos = function(videos) {
            streams = videos;
            // @todo: swap videos
        };

        this.selectPlayer = function(playerType) {
            if (playerType === 'main') {
                selectPlayer(videos.children[0]);
                pipIsSelected = false;
            } else {
                pipIsSelected = true;
                selectPlayer(videos.children[1]);
            }
        };
        this.getMainPlayer = function() {
            return videos.children[0];
        };
        // returns the currently selected player
        this.getSelectedPlayer = function() {
            var selectedPlayer = document.querySelectorAll('.video-js')[0];

            // override if a player is selected
            if (document.querySelector('.video-js.usga-selected')) {
                selectedPlayer = document.querySelector(
                    '.video-js.usga-selected',
                );
            }
            return players[selectedPlayer.getAttribute('id')];
        };

        this.switchToMobileView = function() {
            if (container.className.indexOf(' bgs-mobile') == -1) {
                container.className += ' bgs-mobile';

                if (document.querySelector('.video-js')) {
                    setView(views.SINGLE);
                }
                updateSafariControls();
            }
        };

        this.switchToDesktopView = function() {
            if (container.className.indexOf(' bgs-mobile') > -1) {
                container.className = container.className
                    .split(' bgs-mobile')
                    .join('');
                updateSafariControls();
            }
        };

        /* Toggles view from single to pip or pip to single */
        this.toggleView = function() {
            var currentView = config.element.getAttribute('data-view');
            if (currentView && currentView === views.SINGLE) {
                setView(views.PIP);
            } else {
                setView(views.SINGLE);
            }
            isHighlightView = false;
        };

        /* Returns selected view */
        this.getSelectedView = function() {
            var currentView = config.element.getAttribute('data-view');
            return currentView;
        };

        /* Returns video id loaded in main player */
        this.getVideoIdLoadedInMainPlayer = function() {
            var mainPlayer = videos.children[0];
            if (mainPlayer) {
                return mainPlayer.getAttribute('data-video-id');
            }
        };

        /* Returns video id loaded in pip player */
        this.getVideoIdLoadedInPipPlayer = function() {
            var pipPlayer = videos.children[1];
            if (pipPlayer) {
                return pipPlayer.getAttribute('data-video-id');
            }
        };

        /* Returns true if given video id loaded into one of the players */
        this.IsVideoLoadedIntoPlayer = function(videoId) {
            for (var i in players) {
                if (videoId == players[i].getAttribute('data-video-id')) {
                    return true;
                }
            }
            return false;
        };

        this.destroyAllPlayers = function() {
            var next = function() {},
                blankDiv = document.createElement('div');

            for (var i in players) {
                players[i].dispose();
            }

            while (container.firstChild) {
                container.removeChild(container.firstChild);
            }

            next();

            return {
                complete: function(callback) {
                    callback();
                },
            };
        };

        this.disableChannelViews = function() {
            topNavigation.classList.add('disable-view-buttons');
        };
        this.enableChannelViews = function() {
            topNavigation.classList.remove('disable-view-buttons');
        };
        this.disablePipSwap = function() {
            pipControls.querySelector('#swap-button').style.display = 'none';
            this.enableHighlightPipControls();
        };
        this.enablePipSwap = function() {
            if (currentPiPtype != 'highlight') {
                pipControls.querySelector('#swap-button').style.display =
                    'block';
                this.disableHighlightPipControls();
            }
        };
        this.enableHighlightPipControls = function() {
            document.querySelectorAll('.pip-controls').forEach(function(el) {
                el.classList.add('highlight-controls');
            });
        };
        this.disableHighlightPipControls = function() {
            document.querySelectorAll('.pip-controls').forEach(function(el) {
                el.classList.remove('highlight-controls');
            });
        };
        this.addSlateOverrideToMain = function(url) {
            document.querySelectorAll('.video-js')[0].player.pause();
            slate = new USGAPlayer.USGAHTMLSlate(
                document.querySelectorAll('.video-js')[0],
                USGAPlayer.USGAHTMLSlate.Type.OVERRIDE,
                new EventDispatcher(),
            );
            slate.createSlate(url);
            if (videos.children[0].player.isInPictureInPicture()) {
                videos.children[0].player.exitPictureInPicture();
            }

            updateSlateControls();
        };
        this.addSlateOverrideToMainPiP = function(url) {
            document.querySelectorAll('.video-js')[1].player.pause();
            slate = new USGAPlayer.USGAHTMLSlate(
                document.querySelectorAll('.video-js')[1],
                USGAPlayer.USGAHTMLSlate.Type.OVERRIDE,
                new EventDispatcher(),
            );
            slate.createSlate(url);
            updateSlateControls();
        };
        this.removeSlateOverrideToMain = function() {
            document
                .querySelectorAll('.video-js')[0]
                .querySelector('.player-slate')
                .remove();
            document.querySelectorAll('.video-js')[0].player.play();
            updateSlateControls();
        };
        this.removeSlateOverrideToMainPiP = function() {
            document
                .querySelectorAll('.video-js')[1]
                .querySelector('.player-slate')
                .remove();
            document.querySelectorAll('.video-js')[1].player.play();
            updateSlateControls();
        };
        this.removeAllSlates = function() {
            document.querySelector('.player-slate').remove();
            updateSlateControls();
        };
        this.toggleBrowserPiP = function() {
            globalControlBar.toggleBrowserPiP();
        };
    };

    USGAPlayer.prototype = new EventDispatcher();
})();
USGAPlayerInstance = function(
    container,
    config,
    globalControlBar,
    eventDispatcher,
) {
    var usgaPlayerInstance = this,
        isAndroid = false,
        isMobile = {
            Android: function() {
                return navigator.userAgent.match(/Android/i);
            },
            AndroidPhone: function() {
                return navigator.userAgent.match(/(?=.*Android)(?=.*Mobile)/i);
            },
            AndroidTablet: function() {
                return (
                    navigator.userAgent.match(/(?=.*Android)/i) &&
                    !navigator.userAgent.match(/Mobile/i)
                );
            },
        },
        /**
         * handle first frame of playback for each new video loaded into player
         */
        onTimeUpdate = function(e) {
            if (
                !usgaPlayerInstance._initialTimeUpdate &&
                usgaPlayerInstance._player.currentTime() > 0
            ) {
                // check for DVR
                usgaPlayerInstance._globalControlBar.showDVR();

                // resets to false each time a video loads into player
                usgaPlayerInstance._initialTimeUpdate = true;

                // check for an end stream timestamp on the video's custom field
                usgaPlayerInstance._endStreamTimestamp =
                    parseInt(
                        usgaPlayerInstance._player.mediainfo.custom_fields &&
                            usgaPlayerInstance._player.mediainfo.custom_fields
                                .liveendtimestamp,
                    ) || null;

                // if using an end stream timestamp, handle reporting when stream
                // has completed
                if (usgaPlayerInstance._endStreamTimestamp) {
                    usgaPlayerInstance.handleStreamEnd();
                }

                // enable captions if the button is enabled
                if (usgaPlayerInstance._globalControlBar._captionsEnabled) {
                    usgaPlayerInstance._globalControlBar.setCaptionsForPlayer(
                        usgaPlayerInstance._player,
                        'showing',
                    );
                }
            }
        },
        onAdComplete = function() {
            usgaPlayerInstance.adsEnded();
            usgaPlayerInstance.prototype.trigger('adsEnded');
        },
        onIMA3Error = function() {
            onAdComplete();
        },
        onIMA3AdError = function() {
            onAdComplete();
        },
        onAdsRequested = function() {
            usgaPlayerInstance._adsRequested = true;
        };

    this._adsRequested = false;
    this._initialTimeUpdate = false;
    this._globalControlBar = globalControlBar;
    this._endStreamTimestamp = null;
    this._player = null;
    this._playerId = null;
    this._playerElement = null;

    // inherit properties & methods from EventDispatcher
    this.prototype = Object.create(eventDispatcher);

    this.isPlayerSelected = function() {
        return this._playerElement.className.indexOf('usga-selected') > -1;
    };

    this.disposePlayer = function() {
        this._player._adsRequested = false;
        this._player.dispose();
    };

    this.adsEnded = function() {
        this._player._adsRequested = false;
    };

    this.createPlayer = function() {
        var video = document.createElement('video'),
            index = container.children.length;

        video.setAttribute('data-account', config.account);
        video.setAttribute('data-player', config.player);
        video.setAttribute('data-embed', 'default');
        video.setAttribute('data-video', index);
        video.setAttribute('autoplay', true);
        video.setAttribute('muted', true);
        video.setAttribute('playsinline', true);
        video.className = 'video-js';
        if (config.videos && config.videos.length > index) {
            video.setAttribute('data-video-id', config.videos[index].id);
        }
        container.appendChild(video);
        this._player = bc(video);
    };

    /**
     * live players will require a custom field with an estimate of when
     * a stream should end. when a live stream ends, report the event
     * out to the page so it can be captured by third-party analytics
     */
    this.handleStreamEnd = function() {
        var counter = null,
            endDate = new Date(this._endStreamTimestamp);

        counter = setInterval(function() {
            var d = new Date();

            // @todo: add property to this class for when video is live
            // if currently playing live then 'end stream' when reaching timestamp
            // if (d >= endDate && liveIndicators[player.id_]._isLive) {
            if (d >= endDate) {
                usgaPlayerInstance.prototype.trigger('streamEnded', {
                    event: 'complete',
                    video: usgaPlayerInstance._player.mediainfo,
                    player: usgaPlayerInstance._player,
                });

                // stop counter
                clearInterval(counter);
                counter = null;
            }
        }, 1000);
    };

    this.createPlayer();

    this._playerId = this._player.id_;
    this._playerElement = this._player.el();

    if (isMobile.Android()) {
        isAndroid = true;
    }

    this._player.on(['contenttimeupdate', 'timeupdate'], onTimeUpdate);
    this._player.on('ima3error', onIMA3Error);
    this._player.on('ima3-ad-error', onIMA3AdError);
    this._player.on('ads-pod-ended', onAdComplete);
    this._player.on('ads-request', onAdsRequested);
};

window.USGAPlayer.USGAPlayerInstance = USGAPlayerInstance;
USGASlider = function(element, orientation, objToInheritFrom) {
    var usgaSlider = this;
    this._orientation = orientation;

    function Slider(element) {
        var slider = this,
            html =
                "<div class='slider-holder' style='width:100%;height:100%;position:absolute;'>" +
                "<div class='slider' style='position:absolute;''><div /></div>" +
                '</div>';
        this._startPos = 0;
        this._startDragPos = 0;
        this._positionDraggedTo = 0;
        this._container = element;
        element.innerHTML = html;
        this._sliderHolder = element.querySelector('.slider-holder');
        this._slider = element.querySelector('.slider');
        this._container.addEventListener('mousedown', function(e) {
            slider._onStartDrag(e);
        });
        this._container.addEventListener('touchstart', function(e) {
            slider._onStartDrag(e);
        });
        this.dragging = false;
    }

    // inherit properties & methods from EventDispatcher
    Slider.prototype = Object.create(objToInheritFrom.prototype);
    Slider.prototype.constructor = Slider;

    /**
     * Handles dragging of slider horizontally, saving position dragged.
     */
    Slider.prototype._onDragHorizontal = function(e) {
        var currentPos = e.targetTouches ? e.targetTouches[0].pageX : e.clientX,
            delta =
                currentPos -
                this._sliderHolder.getBoundingClientRect().left -
                this._startDragPos;
        // store position dragged to
        this._positionDraggedTo = this._startPos + delta;
        this._setSlider(this._positionDraggedTo / this._container.offsetWidth);
    };

    /**
     * Handles dragging of slider vertically, saving position dragged.
     */
    Slider.prototype._onDragVertical = function(e) {
        var currentPos = e.targetTouches ? e.targetTouches[0].pageY : e.clientY,
            delta =
                currentPos -
                this._sliderHolder.getBoundingClientRect().top -
                this._startDragPos;
        // store position dragged to
        this._positionDraggedTo = this._startPos + delta;
        this._setSlider(
            1 - this._positionDraggedTo / this._container.offsetHeight,
        );
    };

    /**
     * Handles when slider is initially clicked for a drag.
     */
    Slider.prototype._onStartDrag = function(e) {
        var slider = this;

        if (this.dragging) return;
        this.dragging = true;

        // store positions to be used for calculations during drag operation
        if (
            usgaSlider._orientation ==
            USGAPlayer.USGASlider.Orientation.VERTICAL
        ) {
            this._slider.style.width = '100%';
            this._startDragPos = e.targetTouches
                ? e.targetTouches[0].pageY
                : e.clientY;
            this._startDragPos -= this._sliderHolder.getBoundingClientRect().top;
            this._startPos = this._positionDraggedTo = this._startDragPos;
            this._setSlider(1 - this._startPos / this._container.offsetHeight);
            this._onDragHandler = function(e) {
                slider._onDragVertical(e);
            };
        } else {
            this._slider.style.height = '100%';
            this._startDragPos = e.targetTouches
                ? e.targetTouches[0].pageX
                : e.clientX;
            this._startDragPos -= this._sliderHolder.getBoundingClientRect().left;
            this._startPos = this._positionDraggedTo = this._startDragPos;
            this._setSlider(this._startPos / this._container.offsetWidth);
            this._onDragHandler = function(e) {
                slider._onDragHorizontal(e);
            };
        }

        // prevent selection of HTML elements
        document.body.focus();
        document.onselectstart = function() {
            return false;
        };

        this._onEndDragHandler = function(e) {
            slider._onEndDrag(e);
        };

        document.addEventListener('mousemove', this._onDragHandler);
        document.addEventListener('touchmove', this._onDragHandler);

        document.addEventListener('mouseup', this._onEndDragHandler);
        document.addEventListener('touchend', this._onEndDragHandler);
    };

    /**
     * Handles releasing of slider after drag.
     */
    Slider.prototype._onEndDrag = function(e) {
        this.dragging = false;
        document.removeEventListener('mousemove', this._onDragHandler);
        document.removeEventListener('touchmove', this._onDragHandler);
        document.removeEventListener('mouseup', this._onEndDragHandler);
        document.removeEventListener('touchend', this._onEndDragHandler);
        this._onDragHandler = this._onEndDragHandler = null;
        // reenable selection within document
        document.onselectstart = function() {
            return true;
        };
        if (
            usgaSlider._orientation ==
            USGAPlayer.USGASlider.Orientation.VERTICAL
        ) {
            this._setSlider(
                1 - this._positionDraggedTo / this._container.offsetHeight,
            );
        } else {
            this._setSlider(
                this._positionDraggedTo / this._container.offsetWidth,
            );
        }
    };

    /**
     * Sets slider position.
     */
    Slider.prototype._setSlider = function(value) {
        var val = Math.max(0, Math.min(1, value)),
            percent = val * 100 + '%';
        if (
            usgaSlider._orientation ==
            USGAPlayer.USGASlider.Orientation.VERTICAL
        ) {
            this._slider.style.top = percent;
        } else {
            this._slider.style.left = percent;
        }

        this.trigger('change', { value: val, dragging: this.dragging });
    };

    // instantiate & return slider
    var sliderObj = new Slider(element);
    return sliderObj;
};

USGASlider.prototype.Orientation = {
    VERTICAL: 0,
    HORIZONTAL: 1,
};

USGASlider.Orientation = USGASlider.prototype.Orientation;

window.USGAPlayer.USGASlider = USGASlider;

USGAHTMLSlate = function(element, type, objToInheritFrom) {
    var usgaSlate = this,
        SLATE_OVERRIDE = false,
        EMPTY_PLAYER_SLATE_COPY =
            'Click here and select channel from right panel to watch live.',
        _setSlate = function(content, text) {
            switch (type) {
                case usgaSlate.Type.GEO_RESTRICTED:
                    content.className = 'slate-content geo-slate';
                    break;
                case usgaSlate.Type.EMPTY_PLAYER:
                    text.innerHTML = EMPTY_PLAYER_SLATE_COPY;
                    if (element.className.indexOf(' bgs-player-empty') < 0) {
                        element.className += ' bgs-player-empty';
                    }
                    break;
                case usgaSlate.Type.STREAM_ERROR:
                    content.className = 'slate-content error-slate';
                    break;
                case usgaSlate.Type.CONNECT_ERROR:
                    content.className = 'slate-content connect-slate';
                    break;
                case usgaSlate.Type.OVERRIDE:
                    content.className = 'slate-content custom-slate';
                    SLATE_OVERRIDE = true;
                    break;
                default:
                    break;
            }
        };

    this._type = type;
    this._element = element;

    // inherit properties & methods from EventDispatcher
    this.prototype = Object.create(objToInheritFrom);

    this.createSlate = function(overrideSlateImageUrl) {
        var graphicEl = document.createElement('div'),
            contentEl = document.createElement('div'),
            slateEl = document.createElement('div'),
            textEl = document.createElement('div');

        graphicEl.className = 'slate-graphic';
        if (overrideSlateImageUrl) {
            graphicEl.style =
                'background: url(' +
                overrideSlateImageUrl +
                ');background-size: cover; background-repeat: no-repeat;width:100%;height:100%;';
        }
        textEl.className = 'slate-copy';
        contentEl.className = 'slate-content';
        slateEl.className = 'player-slate';

        _setSlate(contentEl, textEl);

        contentEl.appendChild(graphicEl);
        contentEl.appendChild(textEl);

        slateEl.appendChild(contentEl);

        this._element.appendChild(slateEl);
    };
};

USGAHTMLSlate.prototype.Header = { EMPTY_PLAYER: 'Select a Channel' };
USGAHTMLSlate.prototype.Type = {
    GEO_RESTRICTED: 0,
    EMPTY_PLAYER: 1,
    STREAM_ERROR: 2,
    CONNECT_ERROR: 3,
    OVERRIDE: 'OVERRIDE',
};

USGAHTMLSlate.Header = USGAHTMLSlate.prototype.Header;
USGAHTMLSlate.Type = USGAHTMLSlate.prototype.Type;

window.USGAPlayer.USGAHTMLSlate = USGAHTMLSlate;
USGALiveIndicator = function(element, isGlobal, player, objToInheritFrom) {
    var usgaLive = this,
        INNER_TEXT = 'LIVE',
        SEGMENT_THRESHOLD = 11;

    this._player = player;
    this._element = element;
    this._controlBar = this._element.parentElement;
    this._isLive = false;
    this._element.innerHTML = INNER_TEXT;
    this._isGlobalIndicator = isGlobal;

    // inherit properties & methods from EventDispatcher
    this.prototype = Object.create(objToInheritFrom);

    /**
     * enable live indicator & fill progress bar
     */
    this.enableLiveMode = function() {
        if (this._controlBar.className.indexOf('live') == -1) {
            this._controlBar.className += ' live';
        }

        this._isLive = true;

        // fill global control bar's watched length to 100% during live playback
        if (this._controlBar.id == 'player-controls') {
            this._controlBar.querySelector('#playhead-watched').style.width =
                '100%';
        }
    };

    /**
     * disable live indicator
     */
    this.disableLiveMode = function() {
        this._controlBar.className = this._controlBar.className
            .split(' live')
            .join('');
        this._isLive = false;
    };

    /**
     * seek to most recent point in live stream
     * if live stream has completed, then simulate a media complete
     */
    this.seekToLive = function() {
        var seekable = this._player.seekable();
        var livePoint = seekable && seekable.length && seekable.end(0);

        // don't do anything if the source isn't live
        if (
            this._isLive ||
            this._player.duration() !== Infinity ||
            !(livePoint > 0)
        ) {
            return;
        }

        this._player.currentTime(livePoint);
        this._player.play();
        this.enableLiveMode();
    };

    /**
     * @returns true if the player head is at the live point, and false otherwise
     */
    this._isPlayerLive = function() {
        var segEnd, delta;
        var seekable = this._player.seekable();

        if (seekable && seekable.length) {
            segEnd = seekable.end(0);
            if (
                Math.ceil(this._player.currentTime()) >=
                    Math.floor(segEnd) - SEGMENT_THRESHOLD ||
                segEnd === Infinity
            ) {
                return true;
            }
        }

        return false;
    };

    this._removePlayerListeners = function() {
        this._player.off('loadedmetadata', this.onVideoLoad);
        this._player.off(['contentpause', 'pause'], this.onPlayerPause);
        this._player.off('seeking', this.onPlayerSeeking);
        // @todo: implement a timeout for buffer event
        // player.on("waiting", this.onBufferStart.bind(this));
    };

    this._addPlayerHandlers = function() {
        this._player.on('loadedmetadata', this.onVideoLoad);
        this._player.on(['contentpause', 'pause'], this.onPlayerPause);
        this._player.on('seeking', this.onPlayerSeeking);
        // @todo: implement a timeout for buffer event
        // player.on("waiting", this.onBufferStart.bind(this));
    };

    /**
     * set selected player from super classes
     */
    this._setPlayer = function(player) {
        if (!this._isGlobalIndicator) {
            return;
        }

        this._player = player;
        this._removePlayerListeners();
        this._addPlayerHandlers();

        if (this._isPlayerLive()) {
            this.enableLiveMode();
        } else {
            this.disableLiveMode();
        }
    };

    this.onVideoLoad = function() {
        // set up players that are displaying live content
        if (usgaLive._player.duration() == Infinity) {
            usgaLive.enableLiveMode();
            // this._player.on("progress", this.onBufferStart.bind(this));
        } else {
            usgaLive.disableLiveMode();
        }
    };

    /**
     * handle disabling live event indicator when player pauses
     */
    this.onPlayerPause = function() {
        // when swapping in PIP, pause event dispatches; handle properly
        if (!usgaLive._player.paused()) {
            return;
        }
        usgaLive.disableLiveMode();
    };

    /**
     * listen for when a player completes seeking
     */
    this.onPlayerSeeking = function() {
        usgaLive._player.one('seeked', usgaLive.onPlayerSeeked);
    };

    /**
     * verify that a user does not seek to most recent point in stream
     */
    this.onPlayerSeeked = function() {
        if (usgaLive._isPlayerLive()) {
            usgaLive.enableLiveMode();
        } else {
            usgaLive.disableLiveMode();
        }
    };

    /**
     * handle when a user clicks the 'Live' button
     */
    this.onLiveButtonClick = function() {
        if (this._controlBar.className.indexOf('dvr-ready') > -1) {
            this.seekToLive();
        }
    };

    /** @todo: implement a timeout before disabling live for buffer **/
    this.onBufferStart = function() {
        this.disableLiveMode();
        this._player.one('playing', this.onBufferEnd.bind(this));
    };

    this.onBufferEnd = function() {
        //
    };

    // if we receive a player reference on class initialization, add handlers
    if (this._player) {
        this._addPlayerHandlers();
    }

    this._element.addEventListener('click', this.onLiveButtonClick.bind(this));
};

window.USGAPlayer.USGALiveIndicator = USGALiveIndicator;
USGAGlobalVolume = function(
    volumeElement,
    sliderElement,
    players,
    eventDispatcher,
) {
    var usgaVolume = this;

    this._volumeElement = volumeElement;
    this._sliderElement = sliderElement;
    this._parentControls = volumeElement.parentNode;
    this._globalVolume = null;
    this._globalMuteState = false;
    this._volumeSlider = null;
    this._selectedPlayer = null;
    this._players = players;

    // inherit properties & methods from EventDispatcher
    this.prototype = Object.create(eventDispatcher);

    /**
     * retrieves a reference to main content player or ad player depending
     * on state of playback
     */
    this.getPlayerToControl = function() {
        var player =
            this._selectedPlayer.ads.state == 'ad-playback'
                ? this._selectedPlayer.ima3.adPlayer
                : this._selectedPlayer;

        return player;
    };

    /**
     * handle change in volume from slider
     */
    this.onVolumeSliderChange = function(e) {
        var triggeredFromMute = e.data.triggeredFromMute,
            newVolume = e.data.value,
            newVolPercent = Math.floor(100 * newVolume) + '%',
            player = usgaVolume.getPlayerToControl();

        if (triggeredFromMute && usgaVolume._globalMuteState) {
            usgaVolume._volumeElement.className = 'muted';
            usgaVolume._parentControls.querySelector(
                '.volume-filled',
            ).style.width = 0;
            usgaVolume._parentControls.querySelector(
                '#volume-thumb > .slider-holder > .slider',
            ).style.left = '0%';

            return;
        }

        player.volume(newVolume);

        // show muted icon if slider is dragged to zero
        if (newVolume == 0) {
            usgaVolume._volumeElement.className = 'muted';
            usgaVolume._globalMuteState = true;
            player.muted(true);
        } else {
            usgaVolume._volumeElement.className = '';
            usgaVolume._globalMuteState = false;
            player.muted(false);
            usgaVolume._globalVolume = newVolume;
        }

        usgaVolume._parentControls.querySelector(
            '.volume-filled',
        ).style.width = newVolPercent;
        usgaVolume._parentControls.querySelector(
            '#volume-thumb > .slider-holder > .slider',
        ).style.left = newVolPercent;
    };

    /**
     * handle mute/unmute from icon click
     */
    this.onMuteStateChange = function(e) {
        var player = usgaVolume.getPlayerToControl();

        if (player.muted()) {
            player.muted(false);
            usgaVolume._globalMuteState = false;
        } else {
            player.muted(true);
            usgaVolume._globalMuteState = true;
            // save reference to volume before muting
            usgaVolume._globalVolume = player.volume();
        }

        usgaVolume._volumeSlider.trigger('change', {
            value: usgaVolume._globalVolume,
            triggeredFromMute: true,
        });
    };

    /**
     * verify initial player volume for browsers that mute on autoplay
     */
    this.setInitialPlayerVolume = function() {
        var player = usgaVolume.getPlayerToControl();

        usgaVolume._globalMuteState = player.muted();

        if (usgaVolume._globalMuteState) {
            usgaVolume._globalVolume = 1;
            usgaVolume._volumeSlider.trigger('change', {
                value: usgaVolume._globalVolume,
                triggeredFromMute: true,
            });
        }
    };

    /**
     * set player array from super classes
     */
    this.setPlayers = function(arr) {
        this._players = arr;
    };

    /**
     * set selected player from super classes
     */
    this.setSelectedPlayer = function(player) {
        this._selectedPlayer = player;

        if (this._globalMuteState) {
            this._selectedPlayer.muted(true);
        }
    };

    /**
     * reset the selected player so it is inline with the global mute state
     * set in the controls
     */
    this.resetSelectedPlayerMuteState = function() {
        this._selectedPlayer.muted(this._globalMuteState);
    };

    this._volumeElement.addEventListener('click', this.onMuteStateChange);

    this._volumeSlider = new USGAPlayer.USGASlider(
        this._sliderElement,
        USGAPlayer.USGASlider.Orientation.HORIZONTAL,
        eventDispatcher,
    );
    this._volumeSlider.on('change', this.onVolumeSliderChange);
};

window.USGAPlayer.USGAGlobalVolume = USGAGlobalVolume;
USGAGlobalControls = function(container, players) {
    var that = this,
        captionsEl = null,
        playhead = null,
        controlsRendered = false,
        globalControlsEl = document.createElement('div'),
        captionsIntervalTimers = {},
        TIME_FUDGE_FACTOR = 1 / 30,
        ONE_SECOND_INTERVAL = 1000,
        CAPTIONS_MAX_TIME = 150, // milliseconds, 2.5 minutes
        CAPTIONS_INTERVAL_CHECK = 10, // seconds
        is_safari =
            navigator.userAgent.indexOf('Safari') != -1 &&
            navigator.userAgent.indexOf('Chrome') == -1 &&
            navigator.userAgent.indexOf('Edge') == -1,
        isMobile = {
            Android: function() {
                return navigator.userAgent.match(/Android/i);
            },
            AndroidPhone: function() {
                return navigator.userAgent.match(/(?=.*Android)(?=.*Mobile)/i);
            },
            AndroidTablet: function() {
                return (
                    navigator.userAgent.match(/(?=.*Android)/i) &&
                    !navigator.userAgent.match(/Mobile/i)
                );
            },
            iPhone: function() {
                return navigator.userAgent.match(/iPhone|iPod/i);
            },
            iPad: function() {
                return navigator.userAgent.match(/iPad/i);
            },
            iOS: function() {
                return isMobile.iPhone() || isMobile.iPad();
            },
            any: function() {
                return isMobile.Android() || isMobile.iOS();
            },
        };

    this._players = players;
    this._globalPlayer = null;
    this._volumeControl = null;
    this._liveIndicator = null;
    this._selectedPlayer = null;
    this._captionsEnabled = false;
    this._adPlayer = false;
    this._isFullScreen = false;
    this._el = globalControlsEl;
    /*
     * detects live content and adds DVR-capable buttons to control bar
     */
    this.showDVR = function() {
        if (this._globalPlayer && this._globalPlayer.duration() == Infinity) {
            if (globalControlsEl.className.indexOf('dvr-ready') == -1) {
                globalControlsEl.className += ' dvr-ready';
            }
        } else {
            globalControlsEl.className = globalControlsEl.className
                .split(' dvr-ready')
                .join('');
        }
    };

    /* creates the global player controls */
    this.createControls = function() {
        // if controls have already been rendered...
        if (controlsRendered) {
            return;
        }

        var html =
            "<div class='play-button'></div>" +
            "<div id='usga-volume-button'></div>" +
            "<div class='volume-menu'>" +
            "<div class='volume-well'>" +
            "<div class='volume-filled'></div>" +
            '</div>' +
            "<div id='volume-thumb'></div>" +
            '</div>' +
            "<div class='live-button'></div>" +
            "<div id='playhead'>" +
            "<div id='playhead-well'>" +
            "<div id='playhead-watched'></div>" +
            '</div>' +
            "<div id='playhead-thumb'></div>" +
            "<div id='playhead-block'></div>" +
            '</div>' +
            "<div id='closed-captions'></div>" +
            "<div id='pip-button'>&#xf121</div>" +
            "<div id='fullscreen-button'></div>";

        globalControlsEl.setAttribute('id', 'player-controls');
        globalControlsEl.innerHTML = html;

        // hide volume slider on mobile devices
        if (isMobile.any()) {
            globalControlsEl.querySelector('.volume-menu').style.display =
                'none';
        }

        // button handlers
        /*
         * @todo: currently duping event handler for adPlayer because for some reason,
         *      that._globalPlayer is not updating to correct reference to adPlayer here.
         */
        globalControlsEl
            .querySelector('.play-button')
            .addEventListener('click', function(event) {
                if (that._adPlayer) {
                    that._globalPlayer.ima3.adPlayer.paused()
                        ? that._globalPlayer.ima3.adPlayer.play()
                        : that._globalPlayer.ima3.adPlayer.pause();
                }
                that._globalPlayer.paused()
                    ? that._globalPlayer.play()
                    : that._globalPlayer.pause();
                event.stopPropagation();
            });

        globalControlsEl
            .querySelector('#fullscreen-button')
            .addEventListener('click', function() {
                that.toggleFullscreen();
            });
        globalControlsEl
            .querySelector('#pip-button')
            .addEventListener('click', this.toggleBrowserPiP);
        // create volume button
        this._volumeControl = new USGAPlayer.USGAGlobalVolume(
            globalControlsEl.querySelector('#usga-volume-button'),
            globalControlsEl.querySelector('#volume-thumb'),
            players,
            this,
        );

        /** playhead and handlers **/
        playhead = new USGAPlayer.USGASlider(
            globalControlsEl.querySelector('#playhead-thumb'),
            USGAPlayer.USGASlider.Orientation.HORIZONTAL,
            this,
        );
        playhead.on('change', function(event) {
            var duration = that._globalPlayer.duration(),
                percent = event.data.value,
                time = duration * percent;

            if (duration == Infinity) {
                time = that.calculateLiveTime(percent);
            }

            // on release of playhead, seek
            if (!playhead.dragging) {
                that._globalPlayer.currentTime(time);
            }

            globalControlsEl.querySelector('#playhead-watched').style.width =
                100 * percent + '%';
        });

        this._liveIndicator = new USGAPlayer.USGALiveIndicator(
            globalControlsEl.querySelector('.live-button'),
            true,
            null,
            this,
        );

        // change class on fullscreen change (needed if escape is used instead of button)
        document.addEventListener(
            'webkitfullscreenchange',
            this.updateFullscreenClass,
        );
        document.addEventListener(
            'mozfullscreenchange',
            this.updateFullscreenClass,
        );
        document.addEventListener(
            'MSFullscreenChange',
            this.updateFullscreenClass,
        );
        document.addEventListener(
            'fullscreenchange',
            this.updateFullscreenClass,
        );

        // append class for mobile devices
        if (isMobile.any()) {
            globalControlsEl.className += ' bgs-mobile bgs-mobile-fade';
            container.addEventListener('touchstart', this.showPlayerControls);
        }

        container.appendChild(globalControlsEl);

        controlsRendered = true;

        captionsEl = globalControlsEl.querySelector('#closed-captions');
        captionsEl.addEventListener('click', this.onCaptionsClick);
    };
    this.toggleBrowserPiP = function() {
        const p = that._globalPlayer;
        if (!p.isInPictureInPicture()) {
            p.requestPictureInPicture();
        } else {
            p.exitPictureInPicture();
        }
    };
    this.showPlayerControls = function() {
        // remove class
        globalControlsEl.className = globalControlsEl.className
            .split(' bgs-mobile-fade')
            .join('');

        // re-add class
        setTimeout(function() {
            globalControlsEl.className += ' bgs-mobile-fade';
        }, 100);
    };

    this.assignAdPlayer = function(player) {
        var next = function() {};
        player.on(['ima3-ready', 'ima3-loaded'], function() {
            next(player.ima3);
        });

        return {
            then: function(callback) {
                next = callback;
            },
        };
    };

    /*
     * hooks up global controls to first player
     */
    this.hookGlobalControls = function(isAdPlayer, selectedId) {
        var id = selectedId
                ? selectedId
                : document
                      .querySelector('.video-js:first-child')
                      .getAttribute('id'),
            player = this._players[id];

        this._adPlayer = isAdPlayer;

        // remove handlers from previous player
        // @todo: I'm checking for an existing player in 'this._players' array. The _players array
        //      now empties itself when the pre-roll ad player gets disposed, before loading the
        //      the layout of 4 players into the DOM. I *might* need to remove & re-add the global
        //      controls when disposing the pre-roll player in order to safely remove these evt listeners
        if (this._globalPlayer && this._globalPlayer.id_ in this._players) {
            this._globalPlayer.off(
                ['contentplay', 'contentpause', 'play', 'pause'],
                this.onGlobalPlayerPlay,
            );
            this._globalPlayer.off(
                ['contenttimeupdate', 'timeupdate'],
                this.onGlobalPlayerTimeUpdate,
            );
        }

        if (isAdPlayer) {
            this.assignAdPlayer(player).then(function(callbackPlayer) {
                that._globalPlayer = callbackPlayer.player;

                // add handlers for current player
                if (callbackPlayer.adPlayer) {
                    callbackPlayer.adPlayer.on(
                        ['play', 'pause'],
                        that.onAdPlayerPlay,
                    );
                    callbackPlayer.adPlayer.on(
                        'timeupdate',
                        that.onGlobalPlayerTimeUpdate,
                    );
                }
            });
        } else {
            this._globalPlayer = player;

            this._liveIndicator._setPlayer(this._globalPlayer);

            // detect if player is live
            this.showDVR();

            // add handlers for current player
            this._globalPlayer.on(
                ['contentplay', 'contentpause', 'play', 'pause'],
                this.onGlobalPlayerPlay,
            );
            this._globalPlayer.on(
                ['contenttimeupdate', 'timeupdate'],
                this.onGlobalPlayerTimeUpdate,
            );

            // set controls initial state
            this.onGlobalPlayerPlay();
            this.onGlobalPlayerTimeUpdate();
        }
        // this._globalPlayer.pip();
    };

    /*
     * update container element's fullscreen class
     */
    this.updateFullscreenClass = function(e) {
        if (that._isFullScreen) {
            if (container.className.indexOf(' fullscreen') > -1) {
                container.className = container.className
                    .split(' fullscreen')
                    .join('');
            }

            that._isFullScreen = false;
        } else {
            const player = that._globalPlayer;
            if (container.className.indexOf(' fullscreen') == -1) {
                container.className += ' fullscreen';
            }

            that._isFullScreen = true;

            if (player.isInPictureInPicture()) {
                player.exitPictureInPicture();
            }
        }
    };

    /*
     * toggles fullscreen for player -- not all IE versions will dispatch
     * fullscreenchange event, so call method for updating class when requesting
     * change in IE here
     *
     * NOTE: if user enters full screen during CSAI pre-roll, iOS will exit when
     * that player is disposed prior to loading content. iOS does not appear to
     * allow programmatically entering full screen, so the user is required to
     * manually trigger full screen again
     */
    this.toggleFullscreen = function() {
        var parent = container.parentNode;

        if (
            document.fullscreenElement ||
            document.webkitFullscreenElement ||
            document.mozFullScreenElement ||
            document.msFullscreenElement
        ) {
            // exit full screen
            if (isMobile.iOS() && that._selectedPlayer.exitFullscreen) {
                // handle iOS devices
                this._selectedPlayer.exitFullscreen();
            } else if (document.exitFullscreen) {
                document.exitFullscreen();
            } else if (document.mozCancelFullScreen) {
                document.mozCancelFullScreen();
            } else if (document.webkitExitFullscreen) {
                document.webkitExitFullscreen();
            } else if (document.msExitFullscreen) {
                document.msExitFullscreen();
            }
        } else {
            // enter full screen
            if (isMobile.iOS() && that._selectedPlayer.requestFullscreen) {
                // handle iOS devices
                this._selectedPlayer.requestFullscreen();
            } else if (parent.requestFullscreen) {
                parent.requestFullscreen();
            } else if (parent.mozRequestFullScreen) {
                parent.mozRequestFullScreen();
            } else if (parent.webkitRequestFullscreen) {
                parent.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
            } else if (parent.msRequestFullscreen) {
                parent.msRequestFullscreen();
            }
        }
    };

    /**
     * @returns the total time currently playable in this stream's sliding window
     */
    this.totalPlayerTime = function() {
        var seekable = this._globalPlayer.seekable();

        if (!seekable || !seekable.length) {
            return 0;
        }

        return seekable.end(0) - seekable.start(0);
    };

    this.calculateLiveTime = function(percent) {
        var seekable = that._globalPlayer.seekable();

        if (seekable && seekable.length) {
            var seekableStart = seekable.start(0);
            var seekableEnd = seekable.end(0);
            var seekBarTime = percent * this.totalPlayerTime();

            time = seekableStart + seekBarTime;

            if (time !== Infinity) {
                var seekableEnd = seekable.end(0);

                // Don't let video end while scrubbing.
                if (time >= seekableEnd) {
                    time = seekableEnd - TIME_FUDGE_FACTOR;
                }

                // Compensate for precision differences
                // so that currentTime is not less
                // than seekable start
                if (time <= seekableStart) {
                    time = seekableStart + TIME_FUDGE_FACTOR;
                }
            }
        }

        return time;
    };

    /* handler for clicking captions menu items */
    this.onCaptionsClick = function(e) {
        // enable/disable button
        if (that._captionsEnabled) {
            captionsEl.className = '';
            that._captionsEnabled = false;
            that.setCaptionsForAllPlayers('disabled');
        } else {
            captionsEl.className = ' enabled';
            that._captionsEnabled = true;
            that.setCaptionsForAllPlayers('showing');
        }
    };
    this.getCaptionsState = function() {
        return that._captionsEnabled ? 'showing' : 'disabled';
    };
    /**
     * sets mode to first captions track found on a specified player
     * @param - player: BC player object
     * @param - captionsMode: 'disabled' or 'showing'
     */
    this.setCaptionsForPlayer = function(player, captionsMode) {
        var tracks = player.textTracks(),
            /**
             * set interval when no captions track is available in current segment;
             * enable when captions become available
             */
            startCaptionsCheck = function(playerId) {
                captionsIntervalTimers[playerId] = {
                    counter: 0,
                    interval: null,
                    running: false,
                };

                captionsIntervalTimers[playerId].interval = setInterval(
                    function() {
                        // captionsCounter++;
                        captionsIntervalTimers[playerId].counter++;

                        // check for captions again every 10 seconds
                        if (
                            captionsIntervalTimers[playerId].counter %
                                CAPTIONS_INTERVAL_CHECK ==
                            0
                        ) {
                            that.setCaptionsForPlayer(player, 'showing');
                        }

                        if (
                            captionsIntervalTimers[playerId].counter ==
                            CAPTIONS_MAX_TIME
                        ) {
                            stopCaptionsCheck(playerId);
                        }
                    },
                    ONE_SECOND_INTERVAL,
                );

                captionsIntervalTimers[playerId].running = true;
            },
            /**
             * reset captions interval timer
             */
            stopCaptionsCheck = function(playerId) {
                clearInterval(captionsIntervalTimers[playerId].interval);
                captionsIntervalTimers[playerId].interval = null;
                captionsIntervalTimers[playerId].counter = 0;
                captionsIntervalTimers[playerId].running = false;
            };
        if (!tracks && !tracks.length) {
            this.disableCaptionsForSelectedPlayer();
        } else {
            for (var i = 0, l = tracks.length; i < l; i++) {
                var track = tracks[i];
                if (track.kind == 'captions' || track.kind == 'subtitles') {
                    track.mode = captionsMode;

                    if (
                        captionsIntervalTimers[player.id_] &&
                        captionsIntervalTimers[player.id_].interval
                    ) {
                        stopCaptionsCheck(player.id_);
                    }

                    return;
                }
            }
        }

        // if still running... call check for the player...
        if (
            (!captionsIntervalTimers[player.id_] ||
                !captionsIntervalTimers[player.id_].running) &&
            captionsMode == 'showing' &&
            tracks.length
        ) {
            startCaptionsCheck(player.id_);
        }
    };

    // enable/disable tracks for any players that may have them
    this.setCaptionsForAllPlayers = function(captionsMode) {
        for (var i in that._players) {
            this.setCaptionsForPlayer(that._players[i], captionsMode);
        }
    };

    this.disableCaptionsForSelectedPlayer = function() {
        this.setCaptionsForPlayer(this._selectedPlayer, 'disabled');
    };

    /*
     * handle when play is clicked for Ad Player
     *      @todo: currently duping event handler for adPlayer because for some reason,
     *              that._globalPlayer is not updating to correct reference to adPlayer here.
     */
    this.onAdPlayerPlay = function(evt) {
        if (evt.type == 'pause') {
            globalControlsEl.className = globalControlsEl.className
                .split(' playing')
                .join('');
        } else {
            if (globalControlsEl.className.indexOf('playing') == -1) {
                globalControlsEl.className += ' playing';
            }
        }
    };

    /* handler for global player play/pause */
    this.onGlobalPlayerPlay = function() {
        if (that._globalPlayer.paused()) {
            globalControlsEl.className = globalControlsEl.className
                .split(' playing')
                .join('');
        } else {
            if (globalControlsEl.className.indexOf('playing') == -1) {
                globalControlsEl.className += ' playing';
            }
        }
    };

    /*
     * handles for global player time updates
     */
    this.onGlobalPlayerTimeUpdate = function() {
        var time,
            seekableStart,
            currentPlayer = that._adPlayer
                ? that._globalPlayer.ima3.adPlayer
                : that._globalPlayer,
            seekable = that._adPlayer ? null : currentPlayer.seekable(),
            currentTime = currentPlayer.currentTime(),
            duration = currentPlayer.duration();
        if (playhead.dragging || that._liveIndicator._isLive) return;

        seekableStart = seekable && seekable.length ? seekable.start(0) : 0;

        time =
            duration == Infinity
                ? currentTime - seekableStart
                : 100 * (currentTime / duration) + '%';

        globalControlsEl.querySelector('#playhead-watched').style.width = time;
    };

    // sets selected player and adds handler for fullscreen changes on iOS devices
    this.setSelectedPlayer = function(player) {
        this._selectedPlayer = player;

        // detect webkit fullscreen events against player
        if (isMobile.iOS()) {
            this._selectedPlayer.on(
                'fullscreenchange',
                this.updateFullscreenClass,
            );
            this._selectedPlayer.one('dispose', function() {
                if (that._selectedPlayer.isFullscreen()) {
                    that.updateFullscreenClass();
                }
            });
        }

        this._volumeControl.setSelectedPlayer(player);
    };

    this.setInitialPlayerVolume = function() {
        this._volumeControl.setInitialPlayerVolume();
    };

    this.resetSelectedPlayerMuteState = function() {
        this._volumeControl.resetSelectedPlayerMuteState();
    };

    this.setPlayers = function(arr) {
        this._players = arr;
        this._volumeControl.setPlayers(arr);
    };

    this.getGlobalMuteState = function() {
        return this._volumeControl._globalMuteState;
    };

    this.hideControlBar = function() {
        return (globalControlsEl.style.opacity = 0);
    };

    this.showControlBar = function() {
        return (globalControlsEl.style.opacity = 1);
    };
};

window.USGAPlayer.USGAGlobalControls = USGAGlobalControls;
/**
 * Player Reconnect Class controls redundancy scenarios for handling video
 * playback errors
 */
USGAPlayerReconnect = function(player, debug, objToInheritFrom) {
    var usgaReconnect = this,
        // interval, in milliseconds, for countdown every second
        COUNTDOWN_INTERVAL = 5000,
        // amount, in seconds, countdown should last
        FALLBACK_THRESHOLD = 20,
        PRIMARY_RECONNECT_TIMEOUT = 60,
        PRIMARY_RECONNECT_MAX = 4;

    this._videodata;
    this._primaryStream;
    this._secondaryStream;

    this._fallbackInterval = null;
    this._fallbackCounter = 0;
    this._isFallbackTimerRunning = false;

    this._primaryReconnectInterval = null;
    this._primaryReconnectTimer = 0;
    this._primaryConnectionAttempt = 0;

    this._slate = null;

    this._madeFirstAttempt = false;

    this.prototype = Object.create(objToInheritFrom);

    this._log = function(message) {
        if (debug) {
            console.log('USGAPlayerReconnect:', message);
        }
    };

    this._getLiveJob = function(jobId, done) {
        var xhr = new XMLHttpRequest();
        xhr.onreadystatechange = function() {
            if (xhr.readyState == XMLHttpRequest.DONE) {
                done(JSON.parse(xhr.responseText));
            }
        };
        xhr.open(
            'GET',
            'https://usga-proxy.brightcove.services/v1/jobs/' + jobId,
        );
        xhr.send();
    };

    /**
     * kick off time for falling back to secondary source
     */
    this._startFallBackTimer = function() {
        this._log('***CHECK WHETHER TO START INTERVAL FALLBACK TIMER***');

        if (!this._fallbackInterval && !this._isFallbackTimerRunning) {
            this._fallbackInterval = setInterval(function() {
                usgaReconnect._log(
                    'increment timer every 5 seconds ' +
                        usgaReconnect._fallbackCounter,
                );

                // when timer completes, connect to secondary source
                if (usgaReconnect._fallbackCounter > FALLBACK_THRESHOLD) {
                    usgaReconnect._stopFallBackTimer();
                    if (usgaReconnect._secondaryStream) {
                        usgaReconnect._connectToSecondary();
                    }

                    return;
                }

                usgaReconnect._isFallbackTimerRunning = true;
                usgaReconnect._fallbackCounter += 5;

                if (usgaReconnect._liveJobId) {
                    usgaReconnect._getLiveJob(
                        usgaReconnect._liveJobId,
                        function(data) {
                            usgaReconnect._jobData = data;
                        },
                    );
                }
                if (!usgaReconnect._madeFirstAttempt) {
                    usgaReconnect._madeFirstAttempt = true;
                    usgaReconnect._reconnectToPrimary();
                }
            }, COUNTDOWN_INTERVAL);
        }
    };

    /**
     * stop & reset fallback timer
     */
    this._stopFallBackTimer = function() {
        this._log('STOPPING FALLBACK TIMER');
        clearInterval(this._fallbackInterval);
        this._fallbackInterval = null;
        this._fallbackCounter = 0;
        this._isFallbackTimerRunning = false;
        this._madeFirstAttempt = false;
    };

    /**
     * upon the first successful reconnection to a primary stream, begin a
     * countdown of tracking further attempts to reconnect to the primary stream
     * If the user experiences the MAX amount of reconnects within the timeout
     * period from the first attempt, fallback to the secondary stream
     */
    this._startPrimaryAttemptTracker = function() {
        // increment primary attempts
        this._primaryConnectionAttempt++;
        this._log(
            'Primary Connection Attempt ' +
                this._primaryConnectionAttempt +
                ' out of ' +
                PRIMARY_RECONNECT_MAX,
        );
        // start timer if this is the first attempt
        if (this._primaryConnectionAttempt == 1) {
            usgaReconnect._primaryReconnectInterval = setInterval(function() {
                // when timer finishes, reset; take no further action
                if (
                    usgaReconnect._primaryReconnectTimer >
                    PRIMARY_RECONNECT_TIMEOUT
                ) {
                    usgaReconnect._stopPrimaryAttemptTracker();
                }

                usgaReconnect._primaryReconnectTimer++;
                usgaReconnect._log(
                    'Primary Reconnect Tracker ' +
                        usgaReconnect._primaryReconnectTimer +
                        ' of ' +
                        PRIMARY_RECONNECT_TIMEOUT,
                );
                // when the counter reaches the max, fallback to secondary stream
                if (
                    usgaReconnect._primaryConnectionAttempt >
                    PRIMARY_RECONNECT_MAX
                ) {
                    usgaReconnect._stopPrimaryAttemptTracker();
                    if (usgaReconnect._secondaryStream) {
                        usgaReconnect._connectToSecondary();
                    } else {
                        usgaReconnect._showErrorSlate();
                    }
                }
            }, COUNTDOWN_INTERVAL);
        }
    };

    /**
     * stop & reset primary attempt tracker
     */
    this._stopPrimaryAttemptTracker = function() {
        this._log('STOPPING PRIMARY ATTEMPT TRACKER');
        clearInterval(this._primaryReconnectInterval);
        this._primaryReconnectInterval = null;
        this._primaryConnectionAttempt = 0;
        this._primaryReconnectTimer = 0;
    };

    /**
     * attempt to reconnect to primary while fallback timer is still running
     */
    this._reconnectToPrimary = function() {
        if (this._isFallbackTimerRunning) {
            this._log(
                'TIMER IS STILL RUNNING; ATTEMPT TO CONNECT TO PRIMARY STREAM: ' +
                    this._primaryStream,
            );
            this._loadVideo(this._primaryStream, true);
        }
    };

    /**
     * connect to secondary stream
     */

    this._connectToSecondary = function() {
        this._log(
            'ATTEMPTING TO CONNECT TO SECONDARY STREAM: ' +
                this._secondaryStream,
        );
        this._loadVideo(this._secondaryStream, false);
    };

    this._setStreamData = function() {
        this._videodata = player.mediainfo;
        this._primaryStream = this._videodata.id;
        this._secondaryStream =
            this._videodata.custom_fields &&
            this._videodata.custom_fields.secondarystream;
        this._liveJobId =
            this._videodata.custom_fields &&
            this._videodata.custom_fields.bclivejobid;
        this._jobData = null;
    };

    /**
     * @param videoId - String - id of Brightcove video to load into player
     * @param isPrimary - Boolean - dictates whether stream being loaded is
     *          a primary stream or a secondary stream
     */
    this._loadVideo = function(videoId, isPrimary) {
        var videoData = player.mediainfo;

        // if these listeners are found, remove them
        player.off('error', this._onPrimaryReconnectFail);
        player.off('timeupdate', this._onPrimaryTimeUpdate);

        player.catalog.getVideo(videoId, function(error, data) {
            if (videoData.id !== videoId) {
                usgaReconnect.prototype.trigger('videoExit', {
                    player: player,
                    video: videoData,
                });
            }
            player.catalog.load(data);
        });

        // add listeners for dealing with reconnecting to primary stream
        if (isPrimary) {
            player.on('error', this._onPrimaryReconnectFail);
            player.on('timeupdate', this._onPrimaryTimeUpdate);
        } else {
            player.on('loadstart', this._onSecondaryLoadStart);
            player.on('loadedmetadata', this._onSecondaryLoadedMetaData);
        }
    };

    this._showErrorSlate = function() {
        var slate;
        player.off('error', this._onPrimaryReconnectFail);
        player.off('timeupdate', this._onPrimaryTimeUpdate);

        usgaReconnect.prototype.trigger('hideSlate', { player: player });
        usgaReconnect.prototype.trigger('hideSlate', { player: player });

        slate = new USGAPlayer.USGAHTMLSlate(
            player.el(),
            USGAPlayer.USGAHTMLSlate.Type.CONNECT_ERROR,
            objToInheritFrom,
        );
        slate.createSlate();

        player.pause();
    };

    /**
     * check when a primary has successfully been loaded by detecting when
     * it's begun playing back
     */
    this._onPrimaryTimeUpdate = function() {
        var seekable = player.seekable(),
            livePoint = seekable && seekable.length && seekable.end(0),
            isLive = player.duration() == Infinity;

        if (isLive) player.currentTime(livePoint);

        const isStreaming =
            usgaReconnect._jobData &&
            usgaReconnect._jobData.job.state === 'processing';

        if (
            usgaReconnect._isFallbackTimerRunning &&
            player.currentTime() > 0 &&
            isStreaming
        ) {
            usgaReconnect._log(
                'SUCCESS! PRIMARY TIME UPDATE: ' + player.currentTime(),
            );

            // remove listeners added for reconnecting to the primary
            player.off('error', usgaReconnect._onPrimaryReconnectFail);
            player.off('timeupdate', usgaReconnect._onPrimaryTimeUpdate);

            // stop timer so player doesn't fallback to secondary stream
            usgaReconnect._stopFallBackTimer();

            // start tracking primary reconnect attempts for the next period
            usgaReconnect._startPrimaryAttemptTracker();

            // re-attach original error event
            player.on('error', usgaReconnect._onMediaPlayerError);
            usgaReconnect.prototype.trigger('hideSlate', { player: player });
            usgaReconnect.prototype.trigger('hideSlate', { player: player });
        }
    };

    /**
     * handle when error event has been dispatched for loading a primary reconnect
     */
    this._onPrimaryReconnectFail = function() {
        usgaReconnect._log(
            'PRIMARY RECONNECT HAS FAILED; TRY AGAIN IF TIMER IS STILL RUNNING',
        );

        if (usgaReconnect._isFallbackTimerRunning) {
            usgaReconnect._reconnectToPrimary();
        } else {
            usgaReconnect._log('TIMER IS NO LONGER RUNNING');
        }
    };

    /**
     * handle when a new backup stream has been successfully loaded into the player
     */

    this._onSecondaryLoadStart = function() {
        player.off('loadstart', usgaReconnect._onSecondaryLoadStart);

        // hide slate
        usgaReconnect.prototype.trigger('hideSlate', { player: player });
        usgaReconnect.prototype.trigger('hideSlate', { player: player });

        // begin error checking cycle again...
        player.on('error', usgaReconnect._onMediaPlayerError);
    };

    this._onSecondaryLoadedMetaData = function() {
        var playerControls = player.el().querySelector('.usga-controls'),
            seekable = player.seekable(),
            livePoint = seekable && seekable.length && seekable.end(0),
            isLive = player.duration() == Infinity;
        if (isLive) {
            playerControls.className += ' dvr-ready';
            player.currentTime(livePoint);
        } else {
            playerControls.className = playerControls.className
                .split(' dvr-ready')
                .join('');
        }
    };

    /**
     * handle any type of error thrown from the player or media
     */
    this._onMediaPlayerError = function(errorCode) {
        var errorCode = errorCode ? errorCode : player.error().code;

        // return if error caught is a GEO RESTRICTION error
        if (errorCode == 'PLAYER_ERR_GEO_RESTRICTED') {
            usgaReconnect._log(
                'GEO-RESTRICTION ERROR FOUND; DO NOT TRIGGER RECONNECT SCENARIO',
            );
            return;
        }

        usgaReconnect._log(
            'MEDIA PLAYER ERROR; DISPLAY SLATE, BEGIN TIMER, RECONNECT TO PRIMARY',
        );

        player.off('error', usgaReconnect._onMediaPlayerError);

        // put slate up over video
        usgaReconnect.prototype.trigger('showSlate', { player: player });

        // set initial metadata
        usgaReconnect._setStreamData();

        // kick off fallback timer
        usgaReconnect._startFallBackTimer();
    };

    player.on('error', this._onMediaPlayerError);
};

window.USGAPlayer.USGAPlayerReconnect = USGAPlayerReconnect;

